// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"PhotoVerification_gridContainer__1MKdS","gridItem":"PhotoVerification_gridItem__c_7uI"};